/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_Password_PlaceholderInputs */

const en_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const fr_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe`)
};

const de_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

const it_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const ru_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пароль`)
};

const es_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const zh_cn2_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码`)
};

const ja_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワード`)
};

const hi_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड`)
};

const pt_pt2_work_order_publish_auth_password_placeholder = /** @type {(inputs: Work_Order_Publish_Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Work_Order_Publish_Auth_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_password_placeholder = /** @type {((inputs?: Work_Order_Publish_Auth_Password_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_Password_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_auth_password_placeholder(inputs)
	if (locale === "de") return de_work_order_publish_auth_password_placeholder(inputs)
	if (locale === "it") return it_work_order_publish_auth_password_placeholder(inputs)
	if (locale === "ru") return ru_work_order_publish_auth_password_placeholder(inputs)
	if (locale === "es") return es_work_order_publish_auth_password_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_auth_password_placeholder(inputs)
	if (locale === "ja") return ja_work_order_publish_auth_password_placeholder(inputs)
	if (locale === "hi") return hi_work_order_publish_auth_password_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_auth_password_placeholder(inputs)
	return en_work_order_publish_auth_password_placeholder(inputs)
});